import { combineReducers } from 'redux';
import socketUiReducer from './socketUiReducer';
import socketDataReducer from './socketDataReducer';
import feedSocketUiReducer from './feedSocketUiReducer';
import feedSocketDataReducer from './feedSocketDataReducer';

export default combineReducers({
  ui: socketUiReducer,
  data: socketDataReducer,
  feedUi: feedSocketUiReducer,
  feedData: feedSocketDataReducer,
});
